"use strict";

exports.__esModule = true;
exports.Auto = void 0;

var _basic = require("./basic.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

/**
 * Animation with auto start and loop.
 */
var Auto = /*#__PURE__*/function (_Basic) {
  _inheritsLoose(Auto, _Basic);

  function Auto() {
    var _this;

    _this = _Basic.apply(this, arguments) || this;
    _this.playDelay = null;
    return _this;
  }

  var _proto = Auto.prototype;

  _proto.ready = function ready() {
    this.play();
  };

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.resetPlayDelayTimer();

    _Basic.prototype.disconnectedCallback.call(this);
  };

  _proto.complete = function complete() {
    var _this2 = this;

    this.resetPlayDelayTimer();

    if (!this.connected) {
      return;
    }

    if (this.delay > 0) {
      this.playDelay = setTimeout(function () {
        _this2.playFromBegining();
      }, this.delay);
    } else {
      this.playFromBegining();
    }
  };

  _proto.resetPlayDelayTimer = function resetPlayDelayTimer() {
    if (!this.playDelay) {
      return;
    }

    clearTimeout(this.playDelay);
    this.playDelay = null;
  };

  _createClass(Auto, [{
    key: "delay",
    get: function get() {
      return this.element.hasAttribute('delay') ? +(this.element.getAttribute('delay') || 0) : 0;
    }
  }]);

  return Auto;
}(_basic.Basic);

exports.Auto = Auto;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbmltYXRpb25zL2F1dG8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7Ozs7OztBQUVBOzs7SUFHYSxJOzs7QUFBYixrQkFBQTtBQUFBOzs7QUFDSSxVQUFBLFNBQUEsR0FBaUIsSUFBakI7QUFESjtBQXlDQzs7OztTQXRDRyxLLEdBQUEsaUJBQUs7QUFDRCxTQUFLLElBQUw7QUFDSCxHOztTQUVELG9CLEdBQUEsZ0NBQW9CO0FBQ2hCLFNBQUssbUJBQUw7O0FBRUEscUJBQU0sb0JBQU47QUFDSCxHOztTQUVELFEsR0FBQSxvQkFBUTtBQUFBOztBQUNKLFNBQUssbUJBQUw7O0FBRUEsUUFBSSxDQUFDLEtBQUssU0FBVixFQUFxQjtBQUNqQjtBQUNIOztBQUVELFFBQUksS0FBSyxLQUFMLEdBQWEsQ0FBakIsRUFBb0I7QUFDaEIsV0FBSyxTQUFMLEdBQWlCLFVBQVUsQ0FBQyxZQUFLO0FBQzdCLFFBQUEsTUFBSSxDQUFDLGdCQUFMO0FBQ0gsT0FGMEIsRUFFeEIsS0FBSyxLQUZtQixDQUEzQjtBQUdILEtBSkQsTUFJTztBQUNILFdBQUssZ0JBQUw7QUFDSDtBQUNKLEc7O1NBRUQsbUIsR0FBQSwrQkFBbUI7QUFDZixRQUFJLENBQUMsS0FBSyxTQUFWLEVBQXFCO0FBQ2pCO0FBQ0g7O0FBRUQsSUFBQSxZQUFZLENBQUMsS0FBSyxTQUFOLENBQVo7QUFDQSxTQUFLLFNBQUwsR0FBaUIsSUFBakI7QUFDSCxHOzs7O3dCQUVRO0FBQ0wsYUFBTyxLQUFLLE9BQUwsQ0FBYSxZQUFiLENBQTBCLE9BQTFCLElBQXFDLEVBQUUsS0FBSyxPQUFMLENBQWEsWUFBYixDQUEwQixPQUExQixLQUFzQyxDQUF4QyxDQUFyQyxHQUFrRixDQUF6RjtBQUNIOzs7O0VBeENxQixZIiwic291cmNlUm9vdCI6IiJ9